import * as schemas from './schemas';
import * as net from '~/lib/net';

import { AccountsEndpoints } from './endpoints';
import { Balance } from '../models/index';
import { getToken } from "~/apps/shared/services/token";


export async function getBalance(): Promise<Balance> {
  const data = await net.apiPost(AccountsEndpoints.balance(), getToken(), {});
  return schemas.BalanceSchema.load(data);
}
